/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { MachineType } from './MachineType';
import {
    MachineTypeFromJSON,
    MachineTypeFromJSONTyped,
    MachineTypeToJSON,
    MachineTypeToJSONTyped,
} from './MachineType';
import type { MachinePart } from './MachinePart';
import {
    MachinePartFromJSON,
    MachinePartFromJSONTyped,
    MachinePartToJSON,
    MachinePartToJSONTyped,
} from './MachinePart';

/**
 * 
 * @export
 * @interface Machine
 */
export interface Machine {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    siteId?: string;
    /**
     * 
     */
    siteName?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    location?: string;
    /**
     * 
     */
    imageUrl?: string;
    /**
     * 
     */
    yearBuild?: string;
    /**
     * 
     */
    serialNumber?: string;
    /**
     * 
     */
    machineType?: MachineType;
    /**
     * 
     */
    parts?: Array<MachinePart>;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
    /**
     * 
     */
    active?: boolean;
}

/**
 * Check if a given object implements the Machine interface.
 */
export function instanceOfMachine(value: object): value is Machine {
    return true;
}

export function MachineFromJSON(json: any): Machine {
    return MachineFromJSONTyped(json, false);
}

export function MachineFromJSONTyped(json: any, ignoreDiscriminator: boolean): Machine {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'siteName': json['siteName'] == null ? undefined : json['siteName'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'location': json['location'] == null ? undefined : json['location'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'yearBuild': json['yearBuild'] == null ? undefined : json['yearBuild'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'machineType': json['machineType'] == null ? undefined : MachineTypeFromJSON(json['machineType']),
        'parts': json['parts'] == null ? undefined : ((json['parts'] as Array<any>).map(MachinePartFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function MachineToJSON(json: any): Machine {
    return MachineToJSONTyped(json, false);
}

export function MachineToJSONTyped(value?: Machine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'siteId': value['siteId'],
        'siteName': value['siteName'],
        'name': value['name'],
        'description': value['description'],
        'location': value['location'],
        'imageUrl': value['imageUrl'],
        'yearBuild': value['yearBuild'],
        'serialNumber': value['serialNumber'],
        'machineType': MachineTypeToJSON(value['machineType']),
        'parts': value['parts'] == null ? undefined : ((value['parts'] as Array<any>).map(MachinePartToJSON)),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
        'active': value['active'],
    };
}

